module.exports = __webpack_public_path__ + "img/dashboard.83b4e58d.svg";